const Admin = () => {
  return (
    <div>
      <h1>Admin Page1</h1>
    </div>
  );
};

export default Admin;
